import React from "react"
import { matchMentions, matchMentionTagNames } from "shared/imports/sharedHelperFunctions"

const formatAtMention = (username, fullName) => {
    return `[@${username}|||${fullName}]`
}
// normal OOO is not a suggested pattern in React (https://github.com/facebook/react/issues/613#issuecomment-29280175).
// However, this is a usecase where composition is not posible (where the output of a component is a combination of other components)
// because there is a heavy interlacing of behavior that overlaps (defined here), and beahvior that doesnt (defined on the consuming
// classes). But, to quell some of the concerns raised, lets not enter `super` hell, or override methods, and instead rely on
// distinct helper methods,
export class AtMentionMixin extends React.Component {
    loadMentionTags = value => {
        if (value) {
            const matches = value.match(matchMentions)
            if (matches) {
                const mentionTags = matches.reduce((acc, match) => ({ ...acc, ["@" + match.replace(matchMentionTagNames, "")]: match }), {})
                this.setState({ mentionTags })
            }
        }
    }
    transformToStore = value => (
        // transforms each display version of a mention (ex. @HenriqueHarman) into the storable version (ex. [@henrique|||Henrique Harman])
        Object.keys(this.state.mentionTags).reduce((acc, tag) => acc.split(tag).join(this.state.mentionTags[tag]), value)
    )
    transformToDisplay = value => (
        // transforms each stored version of a mention (ex. [@henrique|||Henrique Harman]) into the displayed version (ex. @HenriqueHarman)
        Object.keys(this.state.mentionTags).reduce((acc, tag) => acc.split(this.state.mentionTags[tag]).join(tag), value)
    )
    insertMention = currentValue => selected => {
        // once a user is selected from the select, add their mention with proper notation
        // bur first we need to replace the substring used for filtering the select
        // grab everything to the right of the cursorLocation (the rest of the text)
        const right = currentValue.slice(this.state.cursorLocation + 1)
        // grab everything to the left of the beggining of the current mention
        const left = currentValue.slice(0, this.state.cursorLocation).split("@").slice(0, -1).join("@")
        // create mentionable string for this user

        const atMention = formatAtMention(selected.username, selected.name)

        // finally, create the mention tag key, and the value to be stored
        const showValue = `@${selected.name.split(" ").join("")}`
        const newValue = this.transformToStore(`${left}${atMention} ${right}`)
        this._callOnChange(newValue)
        this.setState({
            mentioning: false,
            cursorLocation: this.state.cursorLocation + atMention.length,
            mentionTags: {
                ...this.state.mentionTags,
                [showValue]: atMention,
            }
        })
    }
    handleAtMentionOnChange = ({ onChange, currentValue, newValue, e }) => {
        let value = newValue || ""
        // split the values and create a tokens array (used to figure out what's the relevant substrng for the mention)
        const oldValueSplit = currentValue.split("")
        const newValueSplit = value.split("")
        const tokens = value.split(/[\s]+/)

        // whether we are adding or removing a character (indicated by the comparative length of old and new values)
        const removing = oldValueSplit.length > newValueSplit.length

        // initialize the needed counters for keeping track of
        // whether we found the changed character,
        let changedChar
        // which token we are currently on,
        let currentTokenIndex = 0
        // and whether we are jumping through whitespace
        let jumpIndex = false
        for (let i = 0; i <  newValueSplit.length; i++) {
            // if we have found the added/removed char, skip the rest
            if (changedChar) {
                continue
            }
            let currentChar = newValueSplit[i]
            if (currentChar !== oldValueSplit[i]) {
                // changedChar is either the added char, or the next character from a removed char
                changedChar = removing ? oldValueSplit[i] : currentChar
            }
            // we are currently in whitespace, keep on skipping
            if ([" ", "\n"].includes(currentChar)) {
                jumpIndex = true
            } else if (jumpIndex) {
                // we are now in a new token
                currentTokenIndex += 1
                jumpIndex = false
            }
        }
        // we get here if the last character was the one removed
        if (!changedChar && removing) {
            changedChar = oldValueSplit.slice(-1)
        }

        // grab the current token and where the cursor is (cursorLocation)
        let currentToken = tokens[currentTokenIndex]
        let cursorLocation =  this._getCursorLocation(e)

        // if we are removing or adding characters, it will open and pass in the updated cursor location, so we want to anchor the select
        let needToAnchor = false

        // now, if our current token is a mention, (starts with @), and has not been terminated by whitespace
        if (currentToken && currentToken[0] === "@" && ![" ", "\n"].includes(changedChar)) {
            if (changedChar === "@") {
                // say we are currently mentioning
                this.setState({ mentioning: true })
            } else {
                needToAnchor = true
                // and if we have added things after @, filter by that (@hen)
                this.setState({
                    mentioning: true,
                    mentionFilter: currentToken.slice(1),
                    // we want to place the select anchor at the beggining of the token
                    toPlaceAnchor: cursorLocation - currentToken.length + 1,
                })
            }
        // if we are not in a mention token, and we added a character, we are no longer mentioning
        } else {
            this.setState({ mentionFilter: "", mentioning: false })
        }
        // finally, store in the `[@username|||name]` format
        value = this._formatOnChangeInput(this.transformToStore(value), e)

        // and keep track of cursor location
        this.setState({ cursorLocation: cursorLocation })
        // make sure to clean up toPlaceAnchor as we move along when not anchoring
        if (!needToAnchor) {
            this.setState({ toPlaceAnchor: cursorLocation })
        }
        return onChange(value)
    }
}

export default AtMentionMixin
